module.exports = __webpack_public_path__ + "assets/lightning-red.5c01e40f.svg";